import React from "react";

const values = [
  {
    title: "Customer Satisfaction",
    description:
      "We will always strive to meet our customers’ expectations and putting their needs first.",
  },
  {
    title: "Integrity and Trust",
    description:
      "All employees will fully comply with the company’s commitment to increase both their performance through clear understanding of its vision and mission.",
  },
  {
    title: "Team Work",
    description:
      "Bunda will build and maintain a culture of recognition, mutual respect and togetherness to promote feedback, effective communication and group work.",
  },
  {
    title: "Employee Development",
    description: `1) Our employees are the key to the company’s success.
     2) We will provide a working environment that is conducive to continuous employee self-development and advancement.
     3) Training will be vital so as to retain a disciplined and motivated workforce.`,
  },
  {
    title: "Corporate Social Responsibility",
    description:
      "As an entity Bunda will actively participate in deserving charitable and social activities.",
  },
];

const CoreValues = () => {
  return (
    <section className="font-serif p-6">
      <h2 className="text-3xl font-semibold text-center text-amber-500 mb-12">
        Our Core Values
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-8">
        {values.map((value, index) => (
          <div key={index} className="space-y-3">
            <h3 className="text-amber-500 font-semibold text-lg">
              {value.title}
            </h3>
            <p className="text-gray-600 whitespace-pre-line">
              {value.description}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default CoreValues;
